<template>
  <!-- Small centered column -->
  <MainLogin title="Recuperar contraseña">
    <div v-if="!loading">

       <b-form-group
        :class="{feedback : sentError}"
        label="Nueva contraseña"
        label-for="password">
        <b-form-input
          type="password"
          name="password"
          id="pwd"
          v-on:change="clear"
          v-model="item.new_password">
        </b-form-input>
        <p v-show="sentError" class="alert alert-danger feedback-message">
          {{info}}
        </p>
      </b-form-group>

      <b-form-group
        :class="{feedback : sentError}"
        label="Repetir contraseña"
        label-for="password">
        <b-form-input
          type="password"
          name="password"
          id="repwd"
          v-on:change="clear"
          v-model="item.re_new_password">
        </b-form-input>
        <transition name="slide-down">
          <p v-show="sentError" class="alert alert-danger feedback-message">
            {{info}}
          </p>
        </transition>
      </b-form-group>

      <b-alert
        variant="success"
        v-if="sentSuccess"
        show>
        {{info}}
      </b-alert>

      <b-row class="mt-4">
        <b-col lg="5">
           <b-btn
            block
            id="reset-button"
            variant="primary"
            @click="reset">
            Guardar contraseña
          </b-btn>
        </b-col>
        <b-col lg="7" class="text-right">
          <b-link
            id="login-button"
            @click="backlogin">
            Regresar
          </b-link>
        </b-col>
      </b-row>
    </div>
    <div v-else class="card-body text-center">
      <p><i class="fa fa-spinner fa-spin fa-3x"></i></p>
      <p>Enviando email ...</p>
    </div>
  </MainLogin>
</template>

<script>
import MainLogin from './MainLogin';

export default {
  name: 'ResetPwd',
  components: {
    MainLogin
  },
  data: function () {
    return {
      loading: false,
      sentSuccess: false,
      sentError: false,
      item: {
        uid: '',
        token: '',
        new_password: '',
        re_new_password: ''
      },
      info: ''
    };
  },
  methods: {
    clear () {
      this.sentSuccess = false;
      this.sentError = false;
    },
    reset () {
      if (this.item.new_password === this.item.re_new_password) {
        this.$http.post('auth/password/reset/confirm/', this.item).then(response => {
          this.info = 'Contraseña cambiada correctamente, redirigiendo a la pantalla de login...';
          this.variant = 'success';
          this.loading = false;
          this.sentSuccess = true;
          this.sentError = false;

          var th = this;
          setTimeout(() => {
            th.$router.push({name: 'Login'});
          }, 2000);
        }).catch(response => {
          if (response.status === 400) {
            var res = [];
            for (let index = 0; index < response.data.new_password.length; index++) {
              const element = response.data.new_password[index];
              if (element === 'This password is too short. It must contain at least 8 characters.') {
                res.push('Contraseña demasiado corta. Debe contener almenos 8 caracteres.');
              }
              if (element === 'This password is entirely numeric.') {
                res.push('La contraseña solo contiene numeros.');
              }
              if (element === 'This password is too common.') {
                res.push('Contraseña demasiado común.');
              }
            }
            this.info = res.join().replace(',', ' ');
            // if(this.info === 'This password is too short. It must contain at least 8 characters. This password is entirely numeric.'){
            //   this.info = 'Contraseña demasiado corta. '
            // }
            this.variant = 'danger';
            this.loading = false;
            this.sentError = true;
          }
        });
      } else {
        this.info = 'Las contraseñas deben ser iguales';
        this.variant = 'danger';
        this.loading = false;
        this.sentError = true;
      }
    },
    backlogin () {
      this.$router.push({name: 'Login'});
    }
  },
  created () {
    var props = this.$route.path.split('/');
    this.item.uid = props[props.length - 2];
    this.item.token = props[props.length - 1];
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Login/ResetPwd.vue